import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=454db38c"
import script from "./ReportsPage.vue?vue&type=script&lang=ts"
export * from "./ReportsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports